import PhoneNumberField from 'javascripts/components/DonateForm/PhoneNumberField';
import React from 'react';
import TitleOptions from 'javascripts/components/DonateForm/TitleOptions';
import cx from 'classnames';
import store from 'javascripts/store';
import {observer} from 'mobx-react';

@observer
class DonorInfoPopoutForm extends React.Component {
  render() {
    return(
      <>
        <div className='flex flex-wrap input-wrapper full-name '>
          {
            store.donateForm.country == 'uk' &&
              <div className='title w-full md-w-1/5'>
                <label className='hidden' htmlFor='title'>Title</label>
                <select
                  className='input border-grey-40 border-solid border rounded-b-none md-rounded-bl md-rounded-tr-none'
                  name='title'
                  onChange={e => store.donateForm.title = e.target.value}
                  value={store.donateForm.title}
                >
                  <TitleOptions />
                </select>
              </div>
          }
          {store.donateForm.isIndividualAccount ? (
            <>
              <div className={cx('-mt-px md-mt-0 md--ml-px w-full', {'md-w-2/5': store.donateForm.country == 'uk', 'md-w-1/2': store.donateForm.country == 'us'})}>
                <label className='hidden' htmlFor='name' />
                <input
                  className={cx('input', {'rounded-b-none md-rounded-r-none md-rounded-bl': store.donateForm.country == 'us', 'rounded-none': store.donateForm.country == 'uk'})}
                  data-parsley-error-message='First name is required'
                  data-parsley-not-a-credit-card-number
                  id='name'
                  name='name'
                  onChange={e => store.donateForm.name = e.target.value}
                  placeholder={this.props.namePlaceholder}
                  required={true}
                  type='text'
                  value={store.donateForm.name}
                />
              </div>
              <div className={cx('-mt-px md-mt-0 md--ml-px w-full', {'md-w-2/5': store.donateForm.country == 'uk', 'md-w-1/2': store.donateForm.country == 'us'})}>
                <label className='hidden' htmlFor='surname' />
                <input
                  className='input rounded-t-none md-rounded-l-none md-rounded-tr'
                  data-parsley-error-message='Last name is required'
                  data-parsley-not-a-credit-card-number
                  id='surname'
                  name='surname'
                  onChange={e => store.donateForm.surname = e.target.value}
                  placeholder={this.props.surnamePlaceholder}
                  required={true}
                  type='text'
                  value={store.donateForm.surname}
                />
              </div>
            </>
          ) : (
            <div className='-mt-px md-mt-0 md--ml-px w-full'>
              <label className='hidden' htmlFor='name' />
              <input
                className='input'
                data-parsley-error-message='Name is required'
                data-parsley-not-a-credit-card-number
                id='name'
                name='name'
                onChange={e => store.donateForm.name = e.target.value}
                placeholder='Name'
                required={true}
                type='text'
                value={store.donateForm.name}
              />
            </div>
          )}
        </div>

        <div className='input-wrapper'>
          <input
            className={cx('rounded border-grey-40', {hidden: store.donateForm.isUserLoggedIn})}
            data-parsley-email-tld={store.donateForm.email}
            data-parsley-error-message='Please enter a valid email address'
            id='email'
            onChange={e => store.donateForm.email = e.target.value}
            placeholder='Email'
            required
            type='email'
            value={store.donateForm.email}
          />
        </div>

        {store.donateForm.showPhoneNumberField &&
          <PhoneNumberField />
        }
      </>
    );
  }
}

export default DonorInfoPopoutForm;
